import { programPageData } from './program-page.model';


export const programPageInfoJson = [
  ...programPageData // ProgramPage靜態設定檔
];
